import { pick } from 'lodash/fp';

import config from '@config';

import createDataSource from '../createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from '../utils';

const BASE_PATHNAME = 'media-tags';

export default () => {
  const dataSource = createDataSource(config.api.url);

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick(['type']),
    }),

    getById: ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json(),

    getEmptyList: getDefaultEmptyList,
  };
};
